export default "__VITE_ASSET__ComN3vhD__"